import {useQuery} from 'react-query';
import getInputLists from '.';

const useGetInputLists = (props: IInputListProps) => {
  const {enabled, ...apiProps} = props || {}; // remove 'enabled' before passing

  const {data, isLoading} = useQuery(
    ['get-input-lists', apiProps],
    () => getInputLists(apiProps),
    {
      enabled:
        !!props.input_group__guid || !!props.input_group__code || props.enabled,
    },
  );

  return {data, isLoading};
};

export default useGetInputLists;
